import React, { useEffect, useState } from "react";
import ExperienceGate from "./ExperienceGate";
import { fetchDestinationExperience } from "./experienceApi";
import { nonePresentation } from "./experienceHelpers";

/**
 * Fetches Admin-configured destination experience and gates children.
 * Use on page routes from experiencePageDestinations (guide, login, …).
 */
export default function DestinationExperienceGate({ destinationType, children }) {
  const [presentation, setPresentation] = useState(null);

  useEffect(
    function () {
      if (!destinationType) {
        setPresentation(nonePresentation());
        return undefined;
      }
      var cancelled = false;
      fetchDestinationExperience(destinationType)
        .then(function (resolved) {
          if (!cancelled) {
            setPresentation(resolved || nonePresentation());
          }
        })
        .catch(function () {
          if (!cancelled) {
            setPresentation(nonePresentation());
          }
        });
      return function () {
        cancelled = true;
      };
    },
    [destinationType]
  );

  return (
    <ExperienceGate
      destinationType={destinationType}
      presentation={presentation || nonePresentation()}
    >
      {children}
    </ExperienceGate>
  );
}
